import React, { lazy, Suspense } from 'react';
import { Spin } from 'antd';
import { Switch, Route, } from 'react-router-dom'; // Redirect
import AuthLayout from '../container/profile/authentication/Index';

const Login = lazy(() => import('../container/profile/authentication/overview/SignIn'));
const ForgotPass = lazy(() => import('../container/profile/authentication/overview/ForgotPassword'));

// function NotFound() {
//   return <Redirect to="/" />;
// }

function FrontendRoutes() {
  return (
    <Switch>
      <Suspense
        fallback={
          <div className="spin">
            <Spin />
          </div>
        }
      >
        <Route exact path="/" component={Login} />
        <Route exact path="/forgotPassword" component={ForgotPass} />
      </Suspense>
    </Switch>
  );
}

export default AuthLayout(FrontendRoutes);
